import { useCallback, useEffect, useState } from "react";
import { useScoreApi, unwrap } from "../api/scoreApi";

// #3349 -- the persisted outcome of the show's last FVD reconcile (ok /
// partial / blocked / error) plus an admin re-run. Not polled: an admin looks
// at this when something seems stuck, and rerun() refreshes it. A failure to
// READ the status is swallowed (outcome stays null): the dashboard must not
// grow an error banner because a status line could not load.
export function useLastReconcile(showId) {
  const scoreApi = useScoreApi();
  const [state, setState] = useState({ outcome: null, loading: true });
  const [rerun, setRerun] = useState({ running: false, error: null });

  const refetch = useCallback(async () => {
    if (!showId) {
      setState({ outcome: null, loading: false });
      return;
    }
    try {
      const data = unwrap(await scoreApi.daySheet.getDaysheetLastReconcile(showId));
      setState({ outcome: data?.lastReconcile ?? null, loading: false });
    } catch {
      setState({ outcome: null, loading: false });
    }
  }, [scoreApi, showId]);

  useEffect(() => {
    setState({ outcome: null, loading: true });
    refetch();
  }, [refetch]);

  const runReconcile = useCallback(async () => {
    setRerun({ running: true, error: null });
    try {
      unwrap(await scoreApi.daySheet.reconcileDaysheet(showId));
      setRerun({ running: false, error: null });
    } catch (err) {
      setRerun({ running: false, error: err });
    }
    await refetch();
  }, [scoreApi, showId, refetch]);

  return { ...state, rerunning: rerun.running, rerunError: rerun.error, runReconcile };
}

export default useLastReconcile;
